import React from "react";
import cn from "classnames";
import styles from "./LeftSideItem.module.scss";
import { Link } from "react-router-dom";
import AppTooltip from "../../shared/AppTooltip/AppTooltip";
import { useScreenSize } from "../../../hooks/useScreenSize";
import { useWindowSize } from "../../../hooks/useWindowSize";

const linkToId = (link) => link?.replace(/\//g, "-").replace(/^-/, "") || "menu-item";

function LeftSideItemContent({
    item,
    displayText,
    displayChildren,
    titleRef,
    goTo,
    activeRouteName,
}) {
    const { isTablet } = useWindowSize();

    const tooltipId = `sidebar-tooltip-${linkToId(item.link)}`;
    const showTooltip = !displayText && !!item.tooltip;

    return (
        <>
            <Link
                className={cn(
                    styles["navigation-item__link"],
                    {
                        ['justify-content-center']: !displayText,
                        [styles.active]: displayText && displayChildren || activeRouteName === item.link,
                        [styles['stroke-hover']]: item?.isStroke,
                    }
                )}
                to={item.link || '/'}
                onClick={e => goTo(e, item.link)}
                {...(showTooltip ? { "data-tooltip-id": tooltipId } : {})}
            >
                <div className={cn(styles["navigation-item__content"])}>
                    <div
                        className={cn("row align-items-center justify-content-center", styles["navigation-item__avatar"])}
                    >
                        <div className={cn("m-0 p-0", styles['navigation-item__icon'], { [styles['stroke-hover-icon']]: item.isStroke })}>
                            {item.icon}
                        </div>
                    </div>
                    <div ref={titleRef} className={styles["navigation-item__title"]}>
                        {item.title}
                    </div>
                </div>
            </Link>

            {showTooltip && (
                <AppTooltip
                    id={tooltipId}
                    place={isTablet ? "left" : "right"}
                    positionStrategy={isTablet ? "fixed" : "absolute"}
                >
                    {item.tooltip}
                </AppTooltip>
            )}
        </>
    );
}

export default LeftSideItemContent;
